import { useLocation } from 'react-router-dom';
import { tenants } from '../data/tenants';
import { isLocalhost } from '../utils/is-localhost';

export const useSelectedTenant = () => {
  const { search } = useLocation();
  let tenantId: string;

  if (isLocalhost()) {
    const regex = /[?&]tenant=([^&]*)/;

    if (regex.test(search)) {
      tenantId = search.match(regex)![1];
    }
  } else {
    tenantId = document.location.host.split('.')[0];
  }

  return tenants.find((tenant) => tenant.id === tenantId);
};
